import React from 'react';
import { BrowserRouter, Route, Routes, Switch, Link } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router';
import { Header, Footer } from './components/Layout/Menu';
import { Route as PageRoute } from './components/Animation';

import { Home, Point, Service, Company, Flow, Contact, News, Post, Partner, Porter } from './pages';

function App() {
  const location = useLocation();
  let decState = '';
  if(location.pathname.match(/\b(posts|contact|post)\b/)) {
    decState = 'noimage';
  } else if(location.pathname.match(/company/)) {
    decState = '';
  } else {
    decState = '';
  }

  return (
    <div>
      <Header />

      <div className="l-section--main" data-state={decState}>
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path={`/`} element={<PageRoute><Home /></PageRoute>} />
          <Route path={`/partner`} element={<PageRoute><Partner /></PageRoute>} />
          <Route path={`/service`} element={<PageRoute><Service /></PageRoute>} />
          <Route path={`/porter`} element={<PageRoute><Porter /></PageRoute>} />
          <Route path={`/flow`} element={<PageRoute><Flow /></PageRoute>} />
          <Route path={`/company`} element={<PageRoute><Company /></PageRoute>} />
          <Route path={`/contact`} element={<PageRoute><Contact /></PageRoute>} />

          {/* POST */}
          <Route path={`/posts`} element={<PageRoute><News /></PageRoute>} />
          <Route path={`/posts/page/:id`} element={<PageRoute><News /></PageRoute>} />
          <Route path={`/post/:postId`} element={<PageRoute><Post type="post" postType="posts" /></PageRoute>} />

          {/* WORKS */}
          {/* <Route path={`/works`} element={<PageRoute><Works /></PageRoute>} /> */}
          {/* <Route path={`/works/page/:id`} element={<PageRoute><Works /></PageRoute>} /> */}
          {/* <Route path={`/post/works/:postId`} element={<PageRoute><Post type="post" postType="works" /></PageRoute>} /> */}

          {/* VOICE */}
          {/* <Route path={`/voice`} element={<PageRoute><Voice /></PageRoute>} />
          <Route path={`/voice/page/:id`} element={<PageRoute><Voice /></PageRoute>} />
          <Route path={`/post/voice/:postId`} element={<PageRoute><Post type="post" postType="voice" /></PageRoute>} /> */}

        </Routes>
      </AnimatePresence>
      </div>

      <Footer />
    </div>
  )
}

export default App;
